/* global swal, axios, Plyr */

// Define the page object with necessary properties
const page = {
    player: null
}

// Extract slug from URL path
const pathArray = window.location.pathname.split('/');
const slugIndex = pathArray.indexOf('e') + 1;
const slug = pathArray[slugIndex];

// Make an API call to fetch video information
function makeApiCall() {
    return axios.get(`../api/f/${slug}`)
        .then(response => {
            if (response.data.success === false) {
                swal('An error occurred!', response.data.description, 'error');
            } else {
                embedVideo(response.data);
            }
        })
        .catch(error => {
            console.error('Error caught in makeApiCall:', error);
            swal('Error', 'An unknown error occurred', 'error');
        });
}

// Function to embed the video
function embedVideo(fileInfo) {
    if (!fileInfo.type.startsWith('video')) {
        window.location.href = `/f/${fileInfo.slug}`;
        return;
    }
    
    const videoContainer = document.getElementById('video-container');
    if (!videoContainer) {
        console.error('Video container not found');
        return;
    }

    // Create and configure the video element
    const videoElement = document.createElement('video');
    videoElement.id = 'player';
    videoElement.className = 'plyr__video-embed';
    videoElement.setAttribute('controls', '');
    videoElement.setAttribute('preload', 'none');

    if (document.referrer) {
        try {
            const refererHostname = new URL(document.referrer).hostname;
            if (refererHostname.includes('simpcity.su')) {
                videoElement.setAttribute('poster', fileInfo.thumbnailUrl);
            }
        } catch (error) {
            console.error('Error processing document.referrer:', error.message);
        }
    }

    videoElement.innerHTML = `<source src="${fileInfo.url}" type="${fileInfo.type}">`;

    videoContainer.innerHTML = '';
    videoContainer.appendChild(videoElement);

    // Plyr setup
    const videoOptions = {
        debug: false,
        tooltips: {
            controls: true
        },
        controls: [
            'play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'
        ],
        autoplay: false,
        ratio: '16:9'
    };

    page.player = new Plyr('#player', videoOptions);

    // Wait for Plyr to be ready
    page.player.on('ready', event => {
        // Create a new download button with an icon
        const downloadButton = document.createElement('button');
        downloadButton.className = 'plyr__control';
        downloadButton.innerHTML = '<i class="fas fa-download"></i>';
        downloadButton.title = 'Download';
        // Function to handle download button click
        downloadButton.addEventListener('click', () => {
            const slug = window.location.pathname.split('/').pop();
            window.open(`https://cyberdrop.me/f/${slug}`, '_blank');
            });

        // Append the download button to the Plyr controls
        const controlsContainer = document.querySelector('.plyr__controls');
        if (controlsContainer) {
            controlsContainer.appendChild(downloadButton);
        } else {
            console.error('Plyr controls container not found');
        }
    });

    // Inject Custom Logo
    const fullscreenButton = document.querySelector('.plyr__controls .plyr__control--overlaid');
    const logoElement = document.createElement('div');
    logoElement.classList.add('custom-logo');
    logoElement.innerHTML = '<img title="homer is drunk" src="https://cyberdrop.me/images/logo_footer.gif" alt="Logo" style="height: 30px;">';

    if (fullscreenButton && fullscreenButton.nextSibling) {
        fullscreenButton.parentNode.insertBefore(logoElement, fullscreenButton.nextSibling);
    } else {
        document.querySelector('.plyr__controls').appendChild(logoElement);
    }
}

page.lastVisit = () => {
    return axios.post(`../api/f/last_visit`, { type: 'file', fileid: page.file.id }).then(response => {
        if (response.data.success === false) {
            return swal('An error occurred!', response.data.description, 'error')
        } else {

        }
    }).catch(page.onInitError)
}

// Initialize the page on DOMContentLoaded
window.addEventListener('DOMContentLoaded', () => {
    makeApiCall();
});
